module.exports = __webpack_public_path__ + "img/yxal.6d2af8cf.png";